/**
 * B2B Welcome Discount — display support (type "b2b_welcome").
 *
 * The discount itself is applied by the Shopify Function (E-Com app): the
 * first `max_free_items` non-excluded UNITS — in the order they were ADDED
 * to the cart — become 100% free. Once the code is in the cart, Shopify
 * exposes the real result in /cart.js (final_line_price = 0 +
 * line_level_discount_allocations). This module NEVER computes prices, it
 * only unifies the display:
 *
 *  - real allocations (preferred): relabel the native "HEYROSI3" discount
 *    pill to "n× GRATIS (Welcome)" and strike through the original line
 *    price next to the discounted one
 *  - prediction fallback (code known but not applied to the cart yet):
 *    mark the lines the Function WILL free — oldest-added first, i.e. the
 *    REVERSE of /cart.js order (which lists newest first)
 *  - progress notice in the cart drawer ("Noch X Gratis-Produkte wählbar")
 *  - fills any [data-b2b-welcome-note] hook (e.g. quick-order page)
 */
(function () {
  var STYLE_ID = 'b2b-welcome-discount-styles';
  var LANG = ((document.documentElement && document.documentElement.lang) || 'de')
    .toLowerCase()
    .split('-')[0];

  var T = LANG === 'en'
    ? {
        freeBadge: function (n) { return (n > 1 ? n + '\u00D7 ' : '') + 'FREE (Welcome)'; },
        progressLeft: function (x) {
          return 'Welcome code active: ' + (x === 1 ? '1 more free product' : x + ' more free products') + ' can be added to your cart.';
        },
        progressFull: function (n) { return 'Welcome code active: your ' + n + ' free products are in the cart.'; },
        note: function (code, n) {
          return 'Code <strong>' + code + '</strong> active: the first <strong>' + n + ' products</strong> you pick are <strong>free</strong> \u2014 deducted automatically at checkout. Tools & sets excluded.';
        }
      }
    : {
        freeBadge: function (n) { return (n > 1 ? n + '\u00D7 ' : '') + 'GRATIS (Welcome)'; },
        progressLeft: function (x) {
          return 'Welcome-Code aktiv: Noch ' + (x === 1 ? '1 Gratis-Produkt' : x + ' Gratis-Produkte') + ' w\u00E4hlbar.';
        },
        progressFull: function (n) { return 'Welcome-Code aktiv: Deine ' + n + ' Gratis-Produkte sind im Warenkorb.'; },
        note: function (code, n) {
          return 'Code <strong>' + code + '</strong> aktiv: Die ersten <strong>' + n + ' gew\u00E4hlten Produkte</strong> erh\u00E4ltst du <strong>gratis</strong> \u2014 der Abzug erfolgt automatisch im Checkout. Tools & Sets ausgenommen.';
        }
      };

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.b2b-welcome-badge{display:inline-block;background:#ebeddf;color:#261918;font-size:11px;font-weight:600;letter-spacing:.02em;padding:2px 8px;border-radius:20px;margin-top:2px;}',
      '.b2b-welcome-del{display:block;color:rgba(38,25,23,.45);font-weight:400;font-size:.85em;text-decoration:line-through;}',
      '.b2b-welcome-progress{display:flex;align-items:center;gap:.5rem;background:#f3f6ee;border:1px solid #d9e3cd;border-radius:8px;padding:.6rem .85rem;font-size:.8rem;line-height:1.4;color:#261918;}',
      '.b2b-welcome-progress svg{flex-shrink:0;}',
      '[data-b2b-welcome-note]{display:none;align-items:center;gap:.5rem;background:#f3f6ee;border:1px solid #d9e3cd;border-radius:8px;padding:.6rem .85rem;font-size:.85rem;line-height:1.4;color:#261918;}',
      '[data-b2b-welcome-note].is-visible{display:flex;}'
    ].join('\n');
    document.head.appendChild(style);
  }

  var GIFT_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7c-1.5 0-4.5-.5-4.5-2.5S10 2 12 4c2-2 4.5-1.5 4.5.5S13.5 7 12 7z" stroke="#4d7c2a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function fmtMoney(cents) {
    if (window.RosentalDiscount && typeof window.RosentalDiscount.formatMoney === 'function') {
      return window.RosentalDiscount.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC';
  }

  /** Active b2b_welcome discount matched against the cart's active code. */
  function activeWelcome() {
    try {
      var cfg = window.RosentalDiscount && window.RosentalDiscount.getCartConfiguration
        ? window.RosentalDiscount.getCartConfiguration()
        : null;
      var code = cfg && cfg.activeCode;
      if (!code) return null;
      var up = String(code).toUpperCase();
      var list = window.themeDiscounts || [];
      for (var i = 0; i < list.length; i++) {
        var d = list[i];
        if (!d || d.type !== 'b2b_welcome') continue;
        var codes = (Array.isArray(d.codes) ? d.codes : (d.code ? [d.code] : []))
          .map(function (c) { return String(c).toUpperCase(); });
        if (codes.indexOf(up) !== -1) {
          return { code: up, codes: codes, config: d, cart: cfg.cart || null };
        }
      }
    } catch (e) { /* noop */ }
    return null;
  }

  function getCart(active) {
    // Always fetch fresh: the discount allocations appear in /cart.js the
    // moment the code is applied — a cached cart would misclassify lines.
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .catch(function () {
        return active.cart && Array.isArray(active.cart.items) ? active.cart : null;
      });
  }

  /**
   * Free units per line from Shopify's REAL discount allocations (the
   * Function already ran in the cart). A welcome allocation is a
   * fixed-amount allocation of the active code worth n × unit price.
   */
  function freeUnitsFromAllocations(item, codes) {
    var allocs = item.line_level_discount_allocations || [];
    var units = 0;
    for (var i = 0; i < allocs.length; i++) {
      var app = allocs[i].discount_application || {};
      var title = String(app.title || '').toUpperCase();
      if (codes.indexOf(title) === -1) continue;
      if (item.price > 0) units += Math.round(allocs[i].amount / item.price);
    }
    return Math.min(units, item.quantity || 0);
  }

  /**
   * Allocation for the display. Prefers Shopify's real allocations; falls
   * back to predicting what the Function will do — units in ADD order
   * (oldest first = /cart.js reversed), skipping excluded products and
   * selling-plan lines. Returns { byKey, used, max, real }.
   */
  function allocateFreeUnits(cart, active) {
    var max = parseInt(active.config.max_free_items, 10) || 3;
    var byKey = {};
    var used = 0;
    var real = false;

    (cart.items || []).forEach(function (item) {
      var units = freeUnitsFromAllocations(item, active.codes);
      if (units > 0) {
        byKey[item.key] = units;
        used += units;
        real = true;
      }
    });

    if (!real) {
      var excluded = (active.config.excluded_products || []).map(String);
      var remaining = max;
      // /cart.js lists the NEWEST line first — the Function frees the
      // first-ADDED units, so walk the list back to front.
      var oldestFirst = (cart.items || []).slice().reverse();
      oldestFirst.forEach(function (item) {
        if (remaining <= 0) return;
        if (item.selling_plan_allocation) return;
        if (excluded.indexOf(String(item.product_id)) !== -1) return;
        var free = Math.min(remaining, item.quantity || 0);
        if (free > 0) {
          byKey[item.key] = free;
          remaining -= free;
        }
      });
      used = max - remaining;
    }

    return { byKey: byKey, used: Math.min(used, max), max: max, real: real };
  }

  /* ------------------------------------------------------------ cleanup */

  function undecorate() {
    document.querySelectorAll('.b2b-welcome-badge').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.b2b-welcome-del').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[data-b2b-welcome-pill]').forEach(function (el) {
      var original = el.getAttribute('data-b2b-welcome-pill');
      if (original) el.textContent = original;
      el.removeAttribute('data-b2b-welcome-pill');
    });
    document.querySelectorAll('.b2b-welcome-progress').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[data-b2b-welcome-note].is-visible').forEach(function (el) {
      el.classList.remove('is-visible');
      el.innerHTML = '';
    });
  }

  /* ---------------------------------------------------------- decorate */

  function decorateLines(cart, active, allocation) {
    var itemsByKey = {};
    (cart.items || []).forEach(function (item) { itemsByKey[item.key] = item; });

    document.querySelectorAll('line-item[data-line-item-key]').forEach(function (line) {
      var key = line.getAttribute('data-line-item-key');
      var free = allocation.byKey[key] || 0;
      var item = itemsByKey[key];
      if (!free || !item) return;

      var badgeText = T.freeBadge(free);

      // Prefer relabeling the native discount pill (Liquid renders the raw
      // code, e.g. "HEYROSI3") so there's exactly ONE consistent marker.
      var relabeled = false;
      line.querySelectorAll('.line-item__discount-pills .discount-pill__code').forEach(function (codeEl) {
        var current = codeEl.getAttribute('data-b2b-welcome-pill') || codeEl.textContent.trim();
        if (active.codes.indexOf(current.toUpperCase()) === -1) return;
        if (!codeEl.getAttribute('data-b2b-welcome-pill')) {
          codeEl.setAttribute('data-b2b-welcome-pill', current);
        }
        codeEl.textContent = badgeText;
        relabeled = true;
      });

      if (!relabeled && !line.querySelector('.b2b-welcome-badge')) {
        var badge = document.createElement('span');
        badge.className = 'b2b-welcome-badge';
        badge.textContent = badgeText;
        var titleStack = line.querySelector('.line-item__info .v-stack.gap-2') ||
          line.querySelector('.line-item__info');
        if (titleStack) titleStack.appendChild(badge);
      }

      // Line price: Liquid already shows the DISCOUNTED final price (0,00 €
      // for fully free lines). Add the struck-through original above it.
      var priceEl = line.querySelector('.line-item__line-price');
      if (
        priceEl &&
        !line.querySelector('.b2b-welcome-del') &&
        typeof item.original_line_price === 'number' &&
        item.original_line_price > (item.final_line_price || 0)
      ) {
        var del = document.createElement('del');
        del.className = 'b2b-welcome-del';
        del.textContent = fmtMoney(item.original_line_price);
        priceEl.parentNode.insertBefore(del, priceEl);
      }
    });
  }

  function decorateProgress(allocation) {
    var firstLine = document.querySelector('#cart-drawer line-item[data-line-item-key]');
    if (!firstLine || !firstLine.parentNode) return;
    if (firstLine.parentNode.querySelector('.b2b-welcome-progress')) return;

    var note = document.createElement('div');
    note.className = 'b2b-welcome-progress';
    var left = allocation.max - allocation.used;
    note.innerHTML = GIFT_SVG + '<span>' +
      (left > 0 ? T.progressLeft(left) : T.progressFull(allocation.max)) +
      '</span>';
    firstLine.parentNode.insertBefore(note, firstLine);
  }

  function decorateNotes(active) {
    var max = parseInt(active.config.max_free_items, 10) || 3;
    document.querySelectorAll('[data-b2b-welcome-note]').forEach(function (el) {
      el.innerHTML = GIFT_SVG + '<span>' + T.note(active.code, max) + '</span>';
      el.classList.add('is-visible');
    });
  }

  /* --------------------------------------------------------------- run */

  var running = false;
  function run() {
    if (running) return;
    running = true;
    Promise.resolve().then(function () {
      var active = activeWelcome();
      if (!active) {
        undecorate();
        running = false;
        return;
      }
      injectStyles();
      return getCart(active).then(function (cart) {
        undecorate();
        decorateNotes(active);
        if (cart && Array.isArray(cart.items) && cart.items.length) {
          var allocation = allocateFreeUnits(cart, active);
          decorateLines(cart, active, allocation);
          decorateProgress(allocation);
        }
        running = false;
      });
    }).catch(function () { running = false; });
  }

  var debounceTimer = null;
  function scheduleRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 120);
  }

  ['cart:change', 'cart:refresh', 'cart-config:update', 'discount:applied', 'discount:removed', 'discount:change', 'cookie:discount:change']
    .forEach(function (evt) { window.addEventListener(evt, scheduleRun); });
  document.addEventListener('cart:change', scheduleRun);
  document.addEventListener('cart:refresh', scheduleRun);

  // Cart drawer re-renders replace the line items — re-decorate whenever
  // new line-item elements appear.
  function observe() {
    if (!document.body) { setTimeout(observe, 100); return; }
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n instanceof HTMLElement &&
              (n.matches && n.matches('line-item') || (n.querySelector && n.querySelector('line-item')))) {
            scheduleRun();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); observe(); });
  } else {
    run();
    observe();
  }
})();
